import escapeHtml from 'escape-html'
import { Editor, Transforms, Element as SlateElement, Text, Node } from 'slate'

// 列表类型 有序/无序
const LIST_TYPES = ['numbered-list', 'bulleted-list']
// 文字排列方式 居左/居中/居右/两边对齐
const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify']

// 序列化-将编辑器的数据格式转为HTML
const serializeToHtml = (node) => {
  if (Text.isText(node)) {
    let string = escapeHtml(node.text)
    if (node.bold) {
      string = `<strong>${string}</strong>`
    }
    if (node.code) {
      string = `<code>${string}</code>`
    }
    if (node.italic) {
      string = `<em>${string}</em>`
    }
    if (node.underline) {
      string = `<u>${string}</u>`
    }
    if (node.color) {
      string = `<span style='color: ${node.color}'>${string}</span>`
    }
    return string
  }

  const children = node.children.map((n) => serializeToHtml(n)).join('')

  let content = ''
  switch (node.type) {
    // 有序列表
    case 'numbered-list':
      content = `<ul>
        ${(node.children || []).map((m) => {
          return `<li>${m.children
            .map((item) => serializeToHtml(item))
            .join('')}</li>`
        })}
      </ul>`
      break
    // 无序列表
    case 'bulleted-list':
      content = `<ol>
        ${(node.children || []).map((m) => {
          return `<li>${m.children
            .map((item) => serializeToHtml(item))
            .join('')}</li>`
        })}
      </ol>`
      break
    // 一级标题
    case 'heading-one':
      content = `<h1>${children}</h1>`
      break
    // 二级标题
    case 'heading-two':
      content = `<h2>${children}</h2>`
      break
    // 引用
    case 'block-quote':
      content = `<blockquote>${children}</blockquote>`
      break
    case 'quote':
      content = `<blockquote><p>${children}</p></blockquote>`
      break
    case 'paragraph':
      if (node.align) {
        content = `<p style='text-align: ${node.align}'>${children}</p>`
      } else if (node.lineHeight) {
        content = `<p style='line-height: ${node.lineHeight}'>${children}</p>`
      } else content = `<p>${children}</p>`
      break
    default:
      content = children
      break
  }

  return content
}

// 序列化-将编辑器的数据格式转为Text
const serializeToText = (nodes) => {
  return nodes.map((n) => Node.string(n)).join('\n')
}

// 块级按钮是否选中
const isBlockActive = (editor, format, blockType = 'type') => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n) =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n[blockType] === format,
    })
  )

  return !!match
}

// 行内按钮是否选中
const isMarkActive = (editor, format) => {
  const marks = Editor.marks(editor)
  return marks ? marks[format] === true : false
}

// 块级按钮点击事件 标题/列表/居中..
const toggleBlock = (editor, format, value, uploadImg) => {
  const isActive = isBlockActive(
    editor,
    format,
    TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
  )
  const isList = LIST_TYPES.includes(format)

  Transforms.unwrapNodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) &&
      SlateElement.isElement(n) &&
      LIST_TYPES.includes(n.type) &&
      !TEXT_ALIGN_TYPES.includes(format),
    split: true,
  })
  let newProperties
  if (TEXT_ALIGN_TYPES.includes(format)) {
    newProperties = {
      align: isActive ? undefined : format,
    }
  } else if (format === 'line-height') {
    newProperties = {
      lineHeight: isActive ? undefined : value,
    }
  } else if (format === 'image') {
    const id = '_upload_img_'
    document.body.insertAdjacentHTML(
      'beforeEnd',
      '<input type="file" id="' +
        id +
        '" name="file" accept=".jpg,.jpeg,.gif,.png"  style="display:none" >'
    )
    document.getElementById(id).click()
    document.getElementById(id).onchange = (e) => {
      const file = e.target.files && e.target.files[0]
      uploadImg(file).then((res) => {
        const { data = [] } = res
        data.forEach((item) => {
          const text = { text: '' }
          const image = { type: 'link', url: item.llink, children: [text] }
          Transforms.insertNodes(editor, image)
          Transforms.insertNodes(editor, {
            type: 'paragraph',
            children: [{ text: '' }],
          })
        })
      })
    }
  } else if (isActive) {
    newProperties = { type: 'paragraph' }
  } else if (isList) {
    newProperties = { type: 'list-item' }
  } else {
    newProperties = { type: format }
  }
  Transforms.setNodes(editor, newProperties)

  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}

// 行内按钮点击事件 加粗/斜体/下划线..
const toggleMark = (editor, format, value) => {
  const isActive = isMarkActive(editor, format)
  if (isActive) {
    Editor.removeMark(editor, format, value)
  } else {
    Editor.addMark(editor, format, format === 'color' ? value : true)
  }
}

export {
  LIST_TYPES,
  TEXT_ALIGN_TYPES,
  serializeToHtml,
  serializeToText,
  isBlockActive,
  isMarkActive,
  toggleBlock,
  toggleMark,
}
